import { createSlice } from "@reduxjs/toolkit";
import { sortBranchesPutTestLast } from "@helpers/sortBranchesPutTestLast";

const initialState = {
  user: {
    status: false,
    token: "",
    branchStatus: "",
    store: 0,
    brandId: null,
    brandInfo: {},
    employeeInfo: {},
    permissions: [],
    features: {}
  },
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setLogin(state, action) {
      const { token, brandId, brandInfo, branchStatus } = action.payload;
      state.user.token = token;
      state.user.status = true;
      state.user.branchStatus = branchStatus;
      state.user.brandId = brandId;
      setPermissions(state, action);
      state.user.brandInfo = brandInfo;
      if (state.user.brandInfo?.branches) {
        state.user.brandInfo.branches = sortBranchesPutTestLast(
          state.user.brandInfo.branches
        );
      }
    },
    setStore(state, action) {
      const { store } = action.payload;
      state.user.store = store;
    },
    setLogout(state) {
      state.user = {
        ...initialState.user,
      };
    },
    setToken(state, action) {
      const { token } = action.payload;
      state.user.token = token || "";
    },
    setPermissions(state, action) {
      const { permissions } = action.payload;
      state.user.permissions = permissions || [];
    },
    setEmployeeInfo(state, action) {
      const { employeeInfo } = action.payload;
      state.user.employeeInfo = employeeInfo || [];
    },
    setFeatures(state, action) {
      const { features } = action.payload;
      state.user.features = features || {};
    },

    updateBrand(state, action) {
      const { logo, imageUrl, name, email, address } = action.payload;
      state.user.brandInfo.brand_logo_url = logo;
      state.user.brandInfo.brand_image_url = imageUrl;
      state.user.brandInfo.brand_name = name;
      state.user.brandInfo.email = email;
      state.user.brandInfo.address = address;
    },
    updateBranchInfo(state, action) {
      const { branchId, ...updates } = action.payload;
      const data = state.user.brandInfo.branches.find(
        (i) => i.id === parseInt(branchId)
      );
      if (data) {
        Object.assign(data, updates);
      }
      if (state.user.brandInfo?.branches) {
        state.user.brandInfo.branches = sortBranchesPutTestLast(
          state.user.brandInfo.branches
        );
      }
      return state;
    },
    createBranch(state, action) {
      const { data } = action.payload;
      state.user.brandInfo.branches.push(data);
      state.user.brandInfo.branches = sortBranchesPutTestLast(
        state.user.brandInfo.branches
      );
    },

    deleteBranch(state, action) {
      const branchId = action.payload;
      state.user.brandInfo.branches = state.user.brandInfo.branches.filter(
        (i) => i.id !== branchId
      );
    },

    setShowBranch(state, action) {
      const { branchId, boolean } = action.payload;
      state.user.brandInfo.branches.find(
        (i) => i.id === branchId
      ).frontend_display = boolean;
    },
    updateBrandMemberLevel(state, action) {
      const { activateLevel } = action.payload;
      state.user.brandInfo.activate_brand_member_level = activateLevel;
    },
  },
});

export const {
  setLogin,
  setStore,
  setLogout,
  updateBrand,
  updateBranchInfo,
  createBranch,
  deleteBranch,
  setShowBranch,
  updateBrandMemberLevel,
  setPermissions,
  setEmployeeInfo,
  setToken,
  setFeatures
} = userSlice.actions;

export default userSlice.reducer;
